import React, { useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { useDispatch } from "react-redux";
import { OverlayPanel } from 'primereact/overlaypanel';
import _ from "lodash";

import { TextInputField, DropDownField, Button, AutoCompleteField } from "../../../helpers";
import Tooltip from "../../../helpers/Tooltip"

import SellerReqItem from "./SellerReqItem";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { getPrevBuyerQuotesForMaterial } from "../../../services/api/buyerQuote";

import { calculateBuyerQuotation, getCompanyShortName, getDateString, getMaterialMasterDetailsTooltip, getPercentile, getProductName, getProductQty, getProductSpecification, numberConversion, round } from "../../../utils";
import { updatedMaterialMasterTemp } from "../../../services/api/materialMasterTemp";
import { insertMaterialMasterInterimThroughBuyerQuote } from "../../../services/api/materialMasterInterim";
import { confirmDialog } from "primereact/confirmdialog";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
        

const ListItem = (props) => {
    const {
        buyerQuoteItems,
        relatedBuyerQuoteItems,
        buyerReqItemDetails,
        sellersData,
        relatedMaterialDetails,
        sellerReqs,
        allSellerDetails,
        handleRemoveListItem,
        setBuyerQuoteItems,
        buyerQuote,
        buyerReq,
        setBuyerQuote,
        requiredApprovals,
        quotationApprovals,
        approvalRequestStatusDetails,
        approvalInstances,
        statusData,
        HSNMasterData,
        selectedBuyerReqItemIds,
        setSelectedBuyerReqItemIds,
        handleMaxLogisticGSTRateChange,
        handleGSTRateOptions,
        isStarRFQ,
        hasNullDocProof,
        brandData,
        handleMaterialDetailsChange,
        setIsLoading,
        initialMaterialDetails,
        handleBuyerReqItemsUpdation,
        handleSellerReqItemsUpdation,
        handleBuyerQuoteItemsUpdation,
        handleMaterialDataUpdationByBuyerReqItemId,
        initialBuyerQuoteItems, 
        getMarginCalc,
        getUnitPriceCalc,
        materialCategories
    } = props

    const { UOM, materialId, productName, varientName, productSpecification, categoryId } = relatedMaterialDetails
    const { qty, buyerReqItemId, UOMValue } = buyerReqItemDetails

    const prevTransactionsPopup = useRef(null)

    const dispatch = useDispatch()

    const [isPrevTransVisible, setIsPrevTransVisible] = useState(false)
    const [isPrevTransLoading, setIsPrevTransLoading] = useState(false)
    const [prevMaterialQuotes, setPrevMaterialQuotes] = useState([])

    const [hsnTitle, setHsnTitle] = useState(null)
    const [searchedMaterialBrands, setSearchedMaterialBrands] = useState([])

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)

    useEffect(() => {
        if (relatedBuyerQuoteItem && prevMaterialQuotes.length === 0) {
            handlePrevTransctions()
        }
    }, [relatedMaterialDetails])

    let relatedBuyerQuoteItem = relatedBuyerQuoteItems.find(eachQuoteItem => {
        return eachQuoteItem.leadTime > 0
    })

    if (!relatedBuyerQuoteItem) {
        relatedBuyerQuoteItem = relatedBuyerQuoteItems.find(eachQuoteItem => {
            return eachQuoteItem.leadTime > 0
        })
    }
    if (!relatedBuyerQuoteItem) {
        relatedBuyerQuoteItem = relatedBuyerQuoteItems?.[0]
    }

    useEffect(()=>{
        if(relatedBuyerQuoteItems){
            if(relatedBuyerQuoteItems[0]?.bQuotHSNCode){
                const HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === relatedBuyerQuoteItems[0]?.bQuotHSNCode)
                if(HSNCodeDetails && HSNCodeDetails.length !== 0){
                    setHsnTitle(HSNCodeDetails[0]?.HSNTitle)
                }
            }
        }
    },[relatedBuyerQuoteItems])

    const handleSelectItemCheckbox = (selectedBuyerReqItem) => {
        let updatedSelectedBuyerReqItemIds = []
        const itemAlreadySelected = selectedBuyerReqItemIds.some(eachBuyerReqItemId => eachBuyerReqItemId === selectedBuyerReqItem)
        if (itemAlreadySelected) {
            updatedSelectedBuyerReqItemIds = selectedBuyerReqItemIds.filter(eachBuyerReqItemId => eachBuyerReqItemId !== selectedBuyerReqItem)
        } else {
            updatedSelectedBuyerReqItemIds = [...selectedBuyerReqItemIds, selectedBuyerReqItem]
        }
        setSelectedBuyerReqItemIds(updatedSelectedBuyerReqItemIds)
    }

    const handleRemoveListItemButton = () => {
        const text = "Are you sure you want to delete the List Item?"
        if (window.confirm(text)) {
            handleRemoveListItem(buyerReqItemId)
        }
    }

    const handleVerifyHSNCode = (e) => {
        if(e.target.value.length > 4){
            const HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === parseFloat(e.target.value))

            if(HSNCodeDetails.length === 0){
                dispatch(raiseToast({severity:'error', detail: "Invalid HSN", life: 3000}))
            }
        }
    }

    const handleBuyerQuoteItemsChange = (event) => {
        let updatedBuyerQuote = { ...buyerQuote }
        if(event.target.name == 'bQuotHSNCode'){
            if(event.target.value.length > 4){
                const HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === parseFloat(event.target.value))
                if(HSNCodeDetails.length !== 0){
                    setHsnTitle(HSNCodeDetails[0]?.HSNTitle)
                    dispatch(raiseToast({severity:'success', detail: `${HSNCodeDetails[0]?.HSNTitle}`, life: 3000}))
                }
                else{
                    setHsnTitle('INVALID HSN')
                }
            }
        }

        let updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0]?.buyerReqItemId) {
                eachBuyerQuoteItem[event.target.name] = event.target.value
            }
            return eachBuyerQuoteItem
        })

        if (event.target.name === "bQuotHSNCode" && !buyerReq?.isURP) {
            let HSNCodeDetails = []
            if (event.target.value.length > 4) {
                HSNCodeDetails = HSNMasterData?.filter(eachCode => eachCode.HSNCode === parseFloat(event.target.value))
            }

            let isGSTRatesChange = false

            updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
                if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0]?.buyerReqItemId) {
                    if (HSNCodeDetails.length === 1) {
                        eachBuyerQuoteItem["gstOptions"] = [HSNCodeDetails?.[0]?.GSTRate]
                        eachBuyerQuoteItem["allHSNGSTRates"] = [HSNCodeDetails?.[0]?.GSTRate]

                        // isGSTRatesChange = true
                    }
                    else if (HSNCodeDetails.length > 1) {
                        const relatedGSTOptions = HSNCodeDetails.map(eachHSNCode => eachHSNCode.GSTRate)
                        eachBuyerQuoteItem["gstOptions"] = relatedGSTOptions
                        eachBuyerQuoteItem["allHSNGSTRates"] = relatedGSTOptions
                    }
                    else if (HSNCodeDetails.length === 0) {
                        eachBuyerQuoteItem["bQuoteGSTRate"] = null
                        eachBuyerQuoteItem["gstOptions"] = []
                        eachBuyerQuoteItem["allHSNGSTRates"] = []

                        isGSTRatesChange = true
                    }
                }
                return eachBuyerQuoteItem
            })

            //update gst options here
            updatedBuyerQuoteItems = handleGSTRateOptions(updatedBuyerQuoteItems, relatedBuyerQuoteItems[0]?.buyerReqItemId)

            if (isGSTRatesChange) {
                updatedBuyerQuote = handleMaxLogisticGSTRateChange(updatedBuyerQuote, updatedBuyerQuoteItems)
            }
        }

        if (event.target.name === "bQuoteGSTRate") {
            updatedBuyerQuote = handleMaxLogisticGSTRateChange(updatedBuyerQuote, updatedBuyerQuoteItems)
        }

        const calculatedResult = calculateBuyerQuotation(updatedBuyerQuote, updatedBuyerQuoteItems)
        console.log("calculatedResult", calculatedResult, event.target.name, event.target.value)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handleLeadTimeBlur = (event) => {
        if (event.target.name === "leadTime") {
            const leadTime = parseInt(event.target.value)
            const allSellerLeadTimes = []

            buyerQuoteItems.map(eachBuyerQuoteItem => {
                if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId && eachBuyerQuoteItem.bQuotSellerQty > 0) {
                    allSellerLeadTimes.push(eachBuyerQuoteItem.sellerLeadTime)
                }
            })

            const maxSellerLeadTime = _.max(allSellerLeadTimes)

            if (leadTime < maxSellerLeadTime) {
                return dispatch(raiseToast({ severity: 'error', detail: "Leadtime should be greater than max seller lead time", life: 3000 }))
            }
        }
    }

    const handleBuyerQuoteListPrice = (event, buyerQuoteItem) => {
        const bQuotListPrice = round(parseFloat(event.target.value), 2)
        const buyerUnitPrice = buyerQuoteItem?.bQuotUnitPrice

        const discountAmount = bQuotListPrice - buyerUnitPrice
        const discountPercent = round((discountAmount / bQuotListPrice) * 100, 2)

        const avgSellerPrice = buyerQuoteItem?.avgSellerPrice
        const marginAmount = buyerUnitPrice - avgSellerPrice
        const marginPercent = round((marginAmount / buyerUnitPrice) * 100, 2)

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (relatedBuyerQuoteItems[0] && eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId) {
                eachBuyerQuoteItem.bQuotDiscountRate = discountPercent
                eachBuyerQuoteItem.bQuotListPrice = event.target.value
                eachBuyerQuoteItem.bQuotMarginRate = marginPercent
            }
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handleBuyerQuoteUnitPrice = (event, buyerQuoteItem) => {
        if(event.target.name === "bQuotUnitPrice" && prevMaterialQuotes.length && !isPrevTransVisible){
            prevTransactionsPopup.current.toggle(event)
            setIsPrevTransVisible(true)
        }

        const bQuotListPrice = buyerQuoteItem.bQuotListPrice
        const buyerUnitPrice = round(parseFloat(event.target.value), 3)
        const avgSellerPrice = buyerQuoteItem.avgSellerPrice

        const { discountPercent, marginPercent } = getUnitPriceCalc(bQuotListPrice, buyerUnitPrice, avgSellerPrice)

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId) {
                eachBuyerQuoteItem.bQuotDiscountRate = discountPercent
                eachBuyerQuoteItem.bQuotUnitPrice = event.target.value
                eachBuyerQuoteItem.bQuotMarginRate = marginPercent
            }
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handlePrevTransctions = async (e) => {
        // prevTransactionsPopup.current.toggle(e)

        setIsPrevTransLoading(true)
        const prevQuotesRes = await getPrevBuyerQuotesForMaterial({ warehouseId: relatedBuyerQuoteItem?.warehouseId, materialId, pmBranchId: buyerReq.pmBranchId })
        if (prevQuotesRes.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: "prevTransRes", detail: prevQuotesRes.data.error, life: 3000 }))
        }

        setIsPrevTransLoading(false)
        setPrevMaterialQuotes(prevQuotesRes.data)
    }

    const renderPrevTransPopupTemplate = (prevMaterialQuotes) => {

        if (!prevMaterialQuotes || prevMaterialQuotes.length === 0) {
            return <p className="text-center">{`No Transactions`}</p>
        }

        if (isPrevTransLoading) {
            return <p className="text-center">Loading...</p>
        }

        return (
            <div className="approval-history" style={{ borderTop: "0.5px solid #e6dddd" }}>
                <table className="custom-table" style={{ width: "100%", borderTop: "0.5px solid #e6dddd" }}>
                    <thead >
                        <tr className="custom-table-tr">
                            <th className="custom-th">Branch</th>
                            <th className="custom-th">Buyer</th>
                            <th className="custom-th">Date</th>
                            <th className="custom-th">Seller Price</th>
                            <th className="custom-th">Buyer Price</th>
                            <th className="custom-th">Margin</th>
                            <th className="custom-th">PO Status</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            prevMaterialQuotes.map((eachTrans) => {
                                let lineItemColor = ``
                                if (eachTrans.status === 'WON') {
                                    lineItemColor = `#13A89D`
                                }
                                else if (eachTrans.status === 'AWAITING') {
                                    lineItemColor = `#a99907`
                                }
                                else {
                                    lineItemColor = `#F1592A`
                                }

                                return (
                                    <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }} key={`app-inst-history${eachTrans.buyerQuoteItemId}`} >
                                        <td className="custom-td" style={{ color: lineItemColor }}>{eachTrans.branchName}</td>
                                        <td className="custom-td" style={{ color: lineItemColor }}>{getCompanyShortName(eachTrans.buyerCompany)}</td>
                                        <td className="custom-td" style={{ color: lineItemColor }}>{getDateString(eachTrans.createdAt)}</td>
                                        <td className="custom-td" style={{ color: lineItemColor }}>₹{eachTrans.sellerUnitPrice}</td>
                                        <td className="custom-td" style={{ color: lineItemColor }}>₹{eachTrans.buyerUnitPrice}</td>
                                        <td className="custom-td" style={{ color: lineItemColor }}>{eachTrans.margin}%</td>
                                        <td className="custom-td" style={{ color: lineItemColor }}>{eachTrans.status}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    const handleDiscountChange = (event, buyerQuoteItem) => {
        const bQuotListPrice = buyerQuoteItem.bQuotListPrice

        const discountPercent = parseFloat(event.target.value)
        const discountAmount = (bQuotListPrice * discountPercent) / 100
        const buyerUnitPrice = round(bQuotListPrice - discountAmount, 2)

        const avgSellerPrice = buyerQuoteItem.avgSellerPrice
        const marginAmount = buyerUnitPrice - avgSellerPrice
        const marginPercent = round((marginAmount / buyerUnitPrice) * 100, 2)

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId) {
                eachBuyerQuoteItem.bQuotDiscountRate = event.target.value
                eachBuyerQuoteItem.bQuotUnitPrice = buyerUnitPrice
                eachBuyerQuoteItem.bQuotMarginRate = marginPercent
            }
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handleMarginChange = (event, buyerQuoteItem) => {
        const avgSellerPrice = buyerQuoteItem.avgSellerPrice
        const bQuotListPrice = buyerQuoteItem.bQuotListPrice
        const marginPercent = parseFloat(event.target.value)

        const { buyerUnitPrice, discountPercent } = getMarginCalc(avgSellerPrice, bQuotListPrice, marginPercent)

        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItems[0].buyerReqItemId) {
                eachBuyerQuoteItem.bQuotMarginRate = event.target.value
                eachBuyerQuoteItem.bQuotUnitPrice = buyerUnitPrice
                eachBuyerQuoteItem.bQuotDiscountRate = discountPercent
            }
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handleUnitPriceEditClick = () => {
        const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
            if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId) {
                return {...eachBuyerQuoteItem, isUnitPriceEditable: true}
            }
            return eachBuyerQuoteItem
        })

        const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
        setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
        setBuyerQuote(calculatedResult.buyerQuote)
    }

    const handleUnitPriceSave = () => {
        if (window.confirm('Do you want to save the changes?')) {
            const relatedInitialBuyerQuoteItem = initialBuyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId)
            let isPriceOverTollerence = false
            const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
                if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId) {
                    const tollerence = ((eachBuyerQuoteItem.bQuotUnitPrice - relatedInitialBuyerQuoteItem.bQuotUnitPrice)/relatedInitialBuyerQuoteItem.bQuotUnitPrice)*100
                    if(Math.abs(tollerence) > 0.5){
                        isPriceOverTollerence = true
                    }
                    return {...eachBuyerQuoteItem, isUnitPriceEditable: false}
                }
                return eachBuyerQuoteItem
            })

            if(isPriceOverTollerence){
                return dispatch(raiseToast({ severity: 'error', detail: `The price shouldn't be more or less than 0.5% of rate contract price`, life: 3000 })) 
            }

            const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
            setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
            setBuyerQuote(calculatedResult.buyerQuote)
        }
    }

    const handleUnitPriceDiscard = () => {
        if (window.confirm('Do you want to disacrd the changes?')) {
            const relatedInitialBuyerQuoteItem = initialBuyerQuoteItems.find(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId)

            const updatedBuyerQuoteItems = buyerQuoteItems.map(eachBuyerQuoteItem => {
                if (eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId) {
                    return {...eachBuyerQuoteItem, isUnitPriceEditable: false, bQuotUnitPrice: relatedInitialBuyerQuoteItem.bQuotUnitPrice}
                }
                return eachBuyerQuoteItem
            })
    
            const calculatedResult = calculateBuyerQuotation(buyerQuote, updatedBuyerQuoteItems)
            setBuyerQuoteItems(calculatedResult.buyerQuoteItems)
            setBuyerQuote(calculatedResult.buyerQuote)
        }
    }

    const renderSellerItemsForListItem = () => {
        return (
            <div>
                <div style={{ height: 6 }} ></div>
                <p className="" style={{ marginTop: 5, marginBottom: 0, fontSize: 13, fontWeight: 'bold' }}>SELLERS:</p>
                
                {relatedBuyerQuoteItems.map((eachByerQuoteItem, index) => {
                    let displayLabel = false
                    if (index === 0) {
                        displayLabel = true
                    }
                    
                    return (
                        <SellerReqItem
                            key={`${eachByerQuoteItem.sellerReqItemId}`}
                            sellersData={sellersData}
                            sellerReqs={sellerReqs}
                            displayLabel={displayLabel}
                            allSellerDetails={allSellerDetails}
                            buyerQuoteItem={eachByerQuoteItem}
                            buyerQuoteItems={buyerQuoteItems}
                            eachByerQuoteItem={eachByerQuoteItem}
                            setBuyerQuoteItems={setBuyerQuoteItems}
                            buyerQuote={buyerQuote}
                            setBuyerQuote={setBuyerQuote}
                            HSNMasterData={HSNMasterData}
                            handleGSTRateOptions={handleGSTRateOptions}
                        />
                    )
                })}
            </div>
        )
    }

    const constructApprovalDetailHTML = (requiredApprovals, approvalInstances, quotationApprovals, statusData, approvalRequestStatusDetails) => {
        const approvalToolTipDisplay = approvalRequestStatusDetails.map(eachRequestDetail => {
            const relatedQuotationApproval = quotationApprovals.find(eachQuoteApproval => eachQuoteApproval.approvalId === eachRequestDetail.approvalId)
            const sortedApprovalInstances = []

            switch (relatedQuotationApproval.approvalTypeId) {
                case 1: //>1lac
                    if (eachRequestDetail.requestStatus) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The Quotation limit exceeds {relatedQuotationApproval.param1}</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0]) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The quotation {relatedQuotationApproval.param1} limit approval is {eachRequestDetail.requestStatus}!</p>
                        )
                    }
                    break
                case 2:
                    if (eachRequestDetail.requestStatus && profit < 0) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The Quotation loss is {eachRequestDetail.approvedMetrics.amount}</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0]) { 
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The quotation {relatedQuotationApproval.param1 === 5000 ? `> ${relatedQuotationApproval.param1}` : `< ${relatedQuotationApproval.param1}`} limit approval is {eachRequestDetail.requestStatus}!</p>
                        )
                    }
                    break
                case 3:
                    if (eachRequestDetail.requestStatus && buyerReqItemDetails.brandId === relatedQuotationApproval.param1) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The {} brand needs approval!</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0] && buyerReqItemDetails.brandId === relatedQuotationApproval.param1) {
                        const approvalStatus = statusData.find(eachStatus => eachStatus.statusId === sortedApprovalInstances?.[0].statusId)

                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The {} approval is {approvalStatus.status}!</p>
                        )
                    }
                    break
                case 4:
                    if (eachRequestDetail.requestStatus && buyerReqItemDetails.categoryId === relatedQuotationApproval.param1) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The {buyerReqItemDetails.categoryName} needs approval!</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0] && buyerReqItemDetails.categoryId === relatedQuotationApproval.param1) {
                        const approvalStatus = statusData.find(eachStatus => eachStatus.statusId === sortedApprovalInstances?.[0].statusId)

                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The {buyerReqItemDetails.categoryName} approval is {approvalStatus.status}!</p>
                        )
                    }
                    break
                case 5:
                    if (eachRequestDetail.requestStatus && buyerReqItemDetails.materialId === eachRequestDetail?.materialId) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>This product voilates best seller combination</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0] && buyerReqItemDetails.materialId === sortedApprovalInstances?.[0]?.materialId) {
                        const approvalStatus = statusData.find(eachStatus => eachStatus.statusId === sortedApprovalInstances?.[0].statusId)

                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The Best seller combination approval is {approvalStatus.status}!</p>
                        )
                    }
                    break
                // case 6:
                //     if (eachRequestDetail.requestStatus) {
                //         return (
                //             <p className="m-0" key={eachRequestDetail.approvalId}>Logistics GST override needs approval!</p>
                //         )
                //     }
                //     else if (sortedApprovalInstances?.[0]) {
                //         const approvalStatus = statusData.find(eachStatus => eachStatus.statusId === sortedApprovalInstances?.[0].statusId)

                //         return (
                //             <p className="m-0" key={eachRequestDetail.approvalId}>The Logistics GST override approval is {approvalStatus.status}!</p>
                //         )
                //     }
                //     break
                case 12: //>5 lac
                    if (eachRequestDetail.requestStatus) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The Quotation limit exceeds {relatedQuotationApproval.param1}</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0]) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The quotation {relatedQuotationApproval.param1} limit approval is {eachRequestDetail.requestStatus}!</p>
                        )
                    }
                    break
                case 13: //>10 lac
                    if (eachRequestDetail.requestStatus) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The Quotation limit exceeds {relatedQuotationApproval.param1}</p>
                        )
                    }
                    else if (sortedApprovalInstances?.[0]) {
                        return (
                            <p className="m-0" key={eachRequestDetail.approvalId}>The quotation {relatedQuotationApproval.param1} limit approval is {eachRequestDetail.requestStatus}!</p>
                        )
                    }
                    break
                default:
                    return null
            }
        })
        return approvalToolTipDisplay
    }

    const renderApprovalsDisplay = () => {
        return (
            <div className="flex justify-content-end col-1 py-0">
                {/* <Button icon="pi pi-exclamation-triangle" rounded severity="warning" className={`custom-tooltip-btn tooltip-${buyerReqItemDetails.buyerReqItemId} cursor-auto`} style={{ height: "30px", width: "30px"}} /> */}
                <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/0370048a-e0db-4fa2-9ef9-ab84df0af52a.png" className={`custom-tooltip-btn tooltip-${buyerReqItemDetails.buyerReqItemId} cursor-auto`} style={{ height: "30px", width: "30px"}} />
                <Tooltip target={`.tooltip-${buyerReqItemDetails.buyerReqItemId}`} position='top' style={{width: "200px"}}>
                    <div className="w-100 flex flex-column">
                        {constructApprovalDetailHTML(requiredApprovals, approvalInstances, quotationApprovals, statusData, approvalRequestStatusDetails)}
                    </div>
                </Tooltip>
            </div>
        )
    }

    const handleProductNameEditClick = () => {
        const updatedRelatedMaterialDetails = {
            ...relatedMaterialDetails,
            isProductNameEditable: !relatedMaterialDetails.isProductNameEditable
        }

        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleMaterialEditClick = () => {
        const updatedRelatedMaterialDetails = {
            ...relatedMaterialDetails,
            isMaterialIdEditable: !relatedMaterialDetails.isMaterialIdEditable
        }

        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleSpecificationEditClick = () => {
        const updatedRelatedMaterialDetails = {
            ...relatedMaterialDetails,
            isSpecificationEditable: !relatedMaterialDetails.isSpecificationEditable
        }

        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleBrandEditClick = () => {
        const updatedRelatedMaterialDetails = {
            ...relatedMaterialDetails,
            isBrandEditable: !relatedMaterialDetails.isBrandEditable
        }

        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleCategoryEditClick = () => {
        const updatedRelatedMaterialDetails = {
            ...relatedMaterialDetails,
            isCategoryEditable: !relatedMaterialDetails.isCategoryEditable
        }

        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleMaterialSpecsChange = (event) => {
        let updatedRelatedMaterialDetails = {...relatedMaterialDetails}
        if(event.target.name === "brand" && typeof(event.target.value) === "object" && event.target.value !== null){
            updatedRelatedMaterialDetails = { ...updatedRelatedMaterialDetails, [event.target.name]: event.target.value.brandId, brandId: event.target.value.brandId }
        }
        else{
            updatedRelatedMaterialDetails = { ...updatedRelatedMaterialDetails, [event.target.name]: event.target.value }
        }
        console.log("updatedRelatedMaterialDetails", updatedRelatedMaterialDetails, event.target)
        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleNewMaterialIdChange = (e) => {
        const updatedRelatedMaterialDetails = {
            ...relatedMaterialDetails,
            newMaterialId: e.target.value
        }

        handleMaterialDetailsChange(updatedRelatedMaterialDetails)
    }

    const handleMaterialSpecsSave = async (inputName) => {
        let inputText = ''
        switch (inputName) {
            case 'productName':
                inputText = 'Product name'
                break;
            case 'productSpecification':
                inputText = 'Specification'
                break;
            case 'brand':
                inputText = 'Brand'
                break;
            case 'categoryId':
                inputText = 'Category'
                break;
            default:
        }

        if (!relatedMaterialDetails[inputName]) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter ${inputText}`, life: 3000 }))
        }

        if (!relatedMaterialDetails.brand && !(typeof (relatedMaterialDetails.brand) === 'number')) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter brand!`, life: 3000 }))
        }

        //check for duplicacy in req

        if (window.confirm('Do you want to save the changes?')) {
            setIsLoading(true)
            const modifiedMaterialDetails = {...relatedMaterialDetails, checkMaterialInAnotherReq: true}
            const materialMasterTempRes = await updatedMaterialMasterTemp(modifiedMaterialDetails)
            if (materialMasterTempRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Material Master Temp", detail: materialMasterTempRes.data.error, life: 3000 }))
            }
            setIsLoading(false)

            const updatedTempMaterial = { 
                ...relatedMaterialDetails, 
                ...materialMasterTempRes.data[0], 
                isProductNameEditable: inputName === 'productName' ? false : relatedMaterialDetails.isProductNameEditable,
                isSpecificationEditable: inputName === 'productSpecification' ? false : relatedMaterialDetails.isSpecificationEditable,
                isBrandEditable: inputName === 'brand' ? false : relatedMaterialDetails.isBrandEditable,
                isCategoryEditable: inputName === 'categoryId' ? false : relatedMaterialDetails.isCategoryEditable
            }
            handleMaterialDetailsChange(updatedTempMaterial)
        }
    }

    const handlePermanentMaterialIdSaveClick = async () => {
        const materialIds = _.uniqBy(buyerQuoteItems.map(eachQuoteItem => eachQuoteItem.materialId))

        if(materialIds.includes(parseInt(relatedMaterialDetails.newMaterialId))){
           return dispatch(raiseToast({ severity: 'error', detail: 'Material Id already exists in this requirement', life: 3000 })) 
        }

        if(relatedMaterialDetails.newMaterialId.length < 5){
            return dispatch(raiseToast({ severity: 'error', detail: 'Material lenght should be more than 5', life: 3000 }))
        }


        const accept = async () => {
            setIsLoading(true)

            const materialMasterInterimRes = await insertMaterialMasterInterimThroughBuyerQuote({
                tempMaterialMaster: {...relatedMaterialDetails}, permMaterialId: relatedMaterialDetails.newMaterialId, buyerReqId: buyerReq.buyerReqId
            })
    
            if (materialMasterInterimRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Permanent material Id assignment failed", detail: materialMasterInterimRes.data.error, life: 3000 }))
            }

            const updatedMaterialDetails = {
                ...relatedMaterialDetails, 
                ...materialMasterInterimRes.data.permMaterialMaster, 
                isMaterialIdEditable: false, newMaterialId: '', 
                isProductNameEditable: false, 
                isSpecificationEditable: false, 
                buyerReqId: buyerReq.buyerReqId
            }  //some data like erp code prod name and spec will still be remained same 
            handleBuyerReqItemsUpdation(relatedMaterialDetails.newMaterialId, relatedMaterialDetails.materialId, updatedMaterialDetails)
            handleSellerReqItemsUpdation(relatedMaterialDetails.newMaterialId, relatedMaterialDetails.materialId)
            handleMaterialDataUpdationByBuyerReqItemId(updatedMaterialDetails)

            // if(buyerQuoteId){
                handleBuyerQuoteItemsUpdation(relatedMaterialDetails.newMaterialId, relatedMaterialDetails.materialId)
            // }

            setIsLoading(false)
        }

        const reject = () => {
            //Nothing happens for now
        }

        confirmDialog({
            message: `This will edit the material Id in requirement & seller req as well, and it is irreversible. Are you sure you want to continue`,
            header: `Assigning permanent material Id(${relatedMaterialDetails.newMaterialId}) to temp material Id(${materialId})`,
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: "No",
            acceptLabel: "Yes",
            accept,
            reject
        })

    }

    const handleMaterialSpecsDiscard = (inputName) => {
        if (window.confirm('Do you want to disacrd the changes?')) {
            const relatedInitialMaterialDetails = initialMaterialDetails.find(eachMaterial => eachMaterial.materialId === relatedMaterialDetails.materialId)

            const updatedRelatedMaterialDetails = {
                ...relatedMaterialDetails,
                [inputName]: relatedInitialMaterialDetails[inputName],
                isProductNameEditable: inputName === 'productName' ? false : relatedMaterialDetails.isProductNameEditable,
                isSpecificationEditable: inputName === 'productSpecification' ? false : relatedMaterialDetails.isSpecificationEditable,
                isMaterialIdEditable: inputName === 'materialId' ? false : relatedMaterialDetails.isMaterialIdEditable,
                isBrandEditable: inputName === 'brand' ? false : relatedMaterialDetails.isBrandEditable,
                isCategoryEditable: inputName === 'categoryId' ? false : relatedMaterialDetails.isCategoryEditable
            }
    
            handleMaterialDetailsChange(updatedRelatedMaterialDetails)
        }
    }

    const searchBrands = (event) => {
        const relatedBrands = brandData.filter(brand => brand.brandName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedMaterialBrands([...relatedBrands])
    }

    const handleCopyPaste = (e) => {
        e.preventDefault()
    }

    const updatedGSTOptions = relatedBuyerQuoteItem?.gstOptions?.map(eachGSTRate => {
        return { label: eachGSTRate.toString(), value: eachGSTRate }
    })

    let totalSellersPrice = 0
    let allSellerLeadTimes = []
    let totalSellerLogisticsAmount = 0

    relatedBuyerQuoteItems?.forEach(eachBuyerQuoteItem => {
        let beforeTax = 0
        let totalTax = 0
        let totalPrice = 0

        if (eachBuyerQuoteItem.bQuotSellerQty) {
            let bQuotSellerQuantity = round(eachBuyerQuoteItem.bQuotSellerQty)
            beforeTax = round(bQuotSellerQuantity * eachBuyerQuoteItem.bQuotSellerPrice)
            totalPrice = beforeTax
            totalTax = 0

            if (eachBuyerQuoteItem.bQuotSellerGSTRate) {
                totalTax = round(eachBuyerQuoteItem.bQuotSellerGSTRate * beforeTax * 0.01)
                totalPrice = totalTax + beforeTax
            }
            if(eachBuyerQuoteItem.sellerUnitLogistics){
                // totalPrice += eachBuyerQuoteItem.sellerUnitLogistics * bQuotSellerQuantity
                totalSellerLogisticsAmount += eachBuyerQuoteItem.sellerUnitLogistics * bQuotSellerQuantity
            }
            if (eachBuyerQuoteItem.bQuotSellerQty > 0) {
                allSellerLeadTimes.push(eachBuyerQuoteItem.sellerLeadTime)
            }
        }
        totalSellersPrice += totalPrice
    })
    let profit = round(relatedBuyerQuoteItem?.bQuoteItemAmountWithTax - totalSellersPrice, 1)
    let profitInDenomination = null
    if (profit || profit === 0) {
        profitInDenomination = `${pmCompanyConfig.currencySymbol}${numberConversion(profit)}`
    }

    const maxSellerLeadTime = _.max(allSellerLeadTimes)

    const disableMargin = relatedBuyerQuoteItem?.bQuotListPrice && !(relatedBuyerQuoteItem?.buyerRateContractId)

    const approvalCond = _.compact(constructApprovalDetailHTML(requiredApprovals, approvalInstances, quotationApprovals, statusData, approvalRequestStatusDetails)).length > 0

    const materialLength = materialId.toString().length    

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed
    const unitPriceDisableCond = !disableMargin && !relatedBuyerQuoteItem?.isUnitPriceEditable  //Getting relatedBuyerQuoteItem undefined in intial render
    
    let brandName = ''
    if(relatedMaterialDetails && typeof(relatedMaterialDetails.brand) === "number"){
        const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === relatedMaterialDetails.brand)
        if(relatedBrand){
            brandName = relatedBrand.brandName
        }
    }else{ 
        brandName = relatedMaterialDetails.brand 
    }

    const displayMaterialDeatils = getMaterialMasterDetailsTooltip({ ...relatedMaterialDetails, brandName: buyerReqItemDetails?.brandName, categoryName: buyerReqItemDetails?.categoryName })

    let profitBackgroundColor = ''
    if(profit < 0){
        profitBackgroundColor = '#f7ebeb'
    }

    let profitClassName = `font-bold text-lg `
    if (profit > 0) {
        profitClassName += `text-teal-700`
    }
    else if (profit < 0) {
        profitClassName += `text-red-700`
    }
    console.log("relatedMaterialDetails", relatedMaterialDetails)
    return (
        <>
            <div className="flex justify-content-between pt-0">
                <div className="text-sm">
                    <p className="text-xsm mb-1" style={{ color: "grey" }} >Category: {buyerReqItemDetails?.categoryName}</p>
                </div>
                <div className="flex justify-content-end">
                    <Button className="m-0 small-btn" icon="pi pi-times-circle"  severity="danger" text onClick={handleRemoveListItemButton} tooltip={"Remove this product from quotation"} tooltipOptions={{showDelay: 1000, hideDelay: 1000, position: "top"}} />
                </div>
            </div>
            <div className="p-card col-12 mb-2 xl:col-12 m-0 audit-product-list-items" style={{ padding: 0, backgroundColor: profitBackgroundColor || '' }} >
                <div className="grid align-items-center" style={{ padding: 15, paddingBottom: 0 }} >
                    <div className="col-11 flex flex-row py-0">
                        <Checkbox className="ml-1 mr-2 mt-2" checked={selectedBuyerReqItemIds.includes(relatedBuyerQuoteItem?.buyerReqItemId)} onChange={() => handleSelectItemCheckbox(relatedBuyerQuoteItem?.buyerReqItemId)} />
                        <div className="flex pl-0 align-items-center">
                            <div className="flex flex-column material-id">
                                <label htmlFor="materialId" style={{ fontSize: "12px", marginBottom: "3px" }} className="flex">
                                    Material Id
                                    {
                                        materialLength >= 7 &&
                                        <>
                                            {
                                                relatedMaterialDetails.isMaterialIdEditable ?
                                                    <div>
                                                        <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={handlePermanentMaterialIdSaveClick}></i>
                                                        <i className='pi pi-times ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => { handleMaterialSpecsDiscard('materialId') }}></i>
                                                    </div>
                                                    :
                                                    <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={handleMaterialEditClick}></i>
                                            }
                                        </>
                                    }
                                </label>
                                <TextInputField 
                                    name="materialId"
                                    value={relatedMaterialDetails.isMaterialIdEditable ? relatedMaterialDetails.newMaterialId : materialId} 
                                    disabled={!relatedMaterialDetails.isMaterialIdEditable} 
                                    id="materialId"
                                    onChange={handleNewMaterialIdChange}
                                    maxLength={relatedMaterialDetails.isMaterialIdEditable ? 7 : 10}
                                    tooltip={!relatedMaterialDetails.isMaterialIdEditable ? displayMaterialDeatils : ''}
                                    tooltipOptions={{ position: 'right', showOnDisabled: true }}
                                    keyfilter="pnum"
                                />
                            </div>
                        </div>
                        
                        <div className="flex flex-column col-12 lg:col-1">
                            <label htmlFor="brand" style={{ fontSize: "12px", marginBottom: "3px" }} className="flex">
                                Brand
                                {
                                    materialLength >= 7 &&
                                    <>
                                        {
                                            relatedMaterialDetails.isBrandEditable ?
                                                <div>
                                                    <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={() => { handleMaterialSpecsSave('brand') }}></i>
                                                    <i className='pi pi-times ml-1 cursor-pointer ml-2' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => { handleMaterialSpecsDiscard('brand') }}></i>
                                                </div>
                                                :
                                                <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={handleBrandEditClick}></i>
                                        }
                                    </>
                                }
                            </label>
                            <AutoCompleteField name="brand" value={brandName} field="brandName" searchMethod={searchBrands} suggestions={searchedMaterialBrands} onChange={handleMaterialSpecsChange} disabled={!relatedMaterialDetails.isBrandEditable} forceSelection onPaste={(e)=>handleCopyPaste(e)} />
                            {/* <DropDownField name="brandId" value={buyerReqItemDetails.brandId} options={brandData} onChange={handleBuyerQuoteItemsChange} optionLabel="brandName" optionValue="brandId" disabled={!relatedMaterialDetails.isBrandEditable} /> */}
                        </div>

                        <div className="flex flex-column col-12 lg:col-2 pl-0 category">
                            <label htmlFor="categoryId" style={{ fontSize: "12px", marginBottom: "3px" }} className="flex">
                                Category
                                {
                                    materialLength >= 7 &&
                                    <>
                                        {
                                            relatedMaterialDetails.isCategoryEditable ?
                                                <div>
                                                    <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={() => { handleMaterialSpecsSave('categoryId') }}></i>
                                                    <i className='pi pi-times ml-1 cursor-pointer ml-2' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => { handleMaterialSpecsDiscard('categoryId') }}></i>
                                                </div>
                                                :
                                                <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={handleCategoryEditClick}></i>
                                        }
                                    </>
                                }
                            </label>
                            <DropDownField name="categoryId" value={categoryId} options={materialCategories} onChange={handleMaterialSpecsChange} optionLabel="categoryName" optionValue="categoryId" disabled={!relatedMaterialDetails.isCategoryEditable} />
                        </div>

                        <div className="flex flex-column col-12 lg:col-2 pl-0 ">
                            <label htmlFor="productName" style={{ fontSize: "12px", marginBottom: "3px" }} className="flex">
                                Product Name
                                {
                                    materialLength >= 7 && 
                                    <>
                                        {
                                            relatedMaterialDetails.isProductNameEditable ?
                                            <div>
                                                <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={() => {handleMaterialSpecsSave('productName')}}></i>
                                                <i className='pi pi-times ml-1 cursor-pointer ml-2' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => {handleMaterialSpecsDiscard('productName')}}></i>
                                            </div> 
                                            :
                                            <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={handleProductNameEditClick}></i>
                                        }
                                    </>
                                }
                            </label>
                            <TextInputField labelText="" name="productName" value={productName} id="productName" disabled={!relatedMaterialDetails.isProductNameEditable} onChange={handleMaterialSpecsChange} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2 xl:col-3 pl-0 specification">
                            <label htmlFor="productSpecification" style={{ fontSize: "12px", marginBottom: "3px" }} className="flex">
                                Specifications
                                {
                                    materialLength >= 7 && 
                                    <>
                                        {
                                            relatedMaterialDetails.isSpecificationEditable ?
                                            <div>
                                                <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={() => {handleMaterialSpecsSave('productSpecification')}}></i>
                                                <i className='pi pi-times ml-1 cursor-pointer ml-2' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => {handleMaterialSpecsDiscard('productSpecification')}}></i>
                                            </div> 
                                            :
                                            <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={handleSpecificationEditClick}></i>
                                        }
                                    </>
                                }
                            </label>
                            <TextInputField 
                                name="productSpecification" 
                                id="productSpecification" 
                                value={materialLength >= 7 ? productSpecification : getProductSpecification(productSpecification, UOM, UOMValue)} 
                                onChange={handleMaterialSpecsChange} disabled={!relatedMaterialDetails.isSpecificationEditable} 
                                tooltip={materialLength >= 7 ? productSpecification : getProductSpecification(productSpecification, UOM, UOMValue)}
                                tooltipOptions={{ position: 'top', showOnDisabled: true }}
                            />
                        </div>
                        <div className="flex flex-column col-12 lg:col-1 w-4rem pl-0">
                            <TextInputField name="quantity" value={getProductQty(qty, UOM, UOMValue)} labelText="Req Qty" keyfilter="pnum" disabled />
                        </div>
                        <div className="flex flex-column col-12 lg:col-1 w-5rem pl-0">
                            <TextInputField labelText="List Price" name="bQuotListPrice" value={relatedBuyerQuoteItem?.bQuotListPrice} errorBorder={relatedBuyerQuoteItem?.bQuotListPrice <= 0} onChange={(event) => handleBuyerQuoteListPrice(event, relatedBuyerQuoteItem)} keyfilter="pnum" />
                        </div>
                        <div className="flex flex-column col-12 lg:col-1 w-5rem pl-0">
                            <TextInputField value={relatedBuyerQuoteItem?.bQuotDiscountRate} onChange={(event) => handleDiscountChange(event, relatedBuyerQuoteItem)} keyfilter="num" labelText="Discount %" disabled={!disableMargin} />
                        </div>
                        <div className="flex flex-column col-12 lg:col-1 pl-0 margin">
                            {
                                <label htmlFor="sellerListPrice" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                    <span className={`${relatedBuyerQuoteItem?.bQuotMarginRate < 0 ? 'text-red-600' : parseFloat(relatedBuyerQuoteItem?.bQuotMarginRate) > 0 ? 'text-teal-700' : ''}`}>Margin %</span>
                                </label>
                            }
                            <TextInputField value={relatedBuyerQuoteItem?.bQuotMarginRate} onChange={(event) => handleMarginChange(event, relatedBuyerQuoteItem)} keyfilter="num" disabled={!disableMargin} />
                        </div>
                        <div className="flex flex-column col-12 lg:col-1 pl-0 seller-deliver-to">
                            <TextInputField value={relatedBuyerQuoteItem?.warehouseName} labelText="Seller Delivery To" disabled />
                        </div>
                    </div>
                    {
                        approvalCond && renderApprovalsDisplay()
                    }
                </div>

                {relatedBuyerQuoteItems?.length > 0 ? (
                    isStarRFQ && hasNullDocProof ? (
                        <p style={{ fontSize: "14px", width: "100%", textAlign: "center", fontWeight: "bold", color: "#f26161" }}>
                            This is a star RFQ! Seller quotation proof is mandatory for all seller quotations before buyer Quote can be generated
                        </p>
                    ) : (
                        <div style={{ backgroundColor: '#eff1f34a', paddingLeft: 15, paddingRight: 15 }}>
                            {renderSellerItemsForListItem()}
                        </div>
                    )
                ) : (
                    <p style={{ fontSize: "14px", width: "100%", textAlign: "center", fontWeight: "bold", color: "#f26161" }}>
                        Please enter minimum number of quotations in Seller Req page to proceed with quotation creation for this item
                    </p>
                )}

                {/* Buyer Row */}
                {relatedBuyerQuoteItems?.length > 0 ?
                    (isStarRFQ && hasNullDocProof ? null : (
                        <div className="grid align-items-center flex-1 list-item-buyer-row " style={{ padding: 15, paddingBottom: 10, paddingTop: 0 }} >
                            <div className="flex flex-column lg:col-2 buyer">
                                <p className="" style={{ marginTop: 5, marginBottom: 0, fontSize: 13, fontWeight: 'bold' }}>BUYER:</p>
                            </div>
                            <div className="flex col-12 lg:col-10 pb-0 pl-0">
                                <div className="flex flex-row pl-0">
                                    <div className="flex flex-column col-12 lg:col-1 pl-0 w-6rem buyer-quantity">
                                        <TextInputField name="totReqQty" value={relatedBuyerQuoteItem?.totReqQty} errorBorder={relatedBuyerQuoteItem?.totReqQty !== qty} onChange={handleBuyerQuoteItemsChange} labelText="Quantity" keyfilter="pnum" disabled={true} />
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 pl-0 avg-seller-pr">
                                        <TextInputField labelText="Avg S.Pr" value={relatedBuyerQuoteItem?.avgSellerPrice} disabled />
                                    </div>
                                    <div className="flex flex-column lg:col-1 pl-0 w-4rem">
                                        <TextInputField labelText="D. period" name="leadTime" tooltipOptions={{showOnDisabled: true}} tooltip={relatedBuyerQuoteItem.isLeadTimeEditable ? "Delivery period in days" : "Lead Time will be considered from Rate Contract and it will be in days"} value={relatedBuyerQuoteItem?.leadTime} errorBorder={relatedBuyerQuoteItem?.leadTime < maxSellerLeadTime} onChange={handleBuyerQuoteItemsChange} onBlur={handleLeadTimeBlur} keyfilter="pnum" disabled={!relatedBuyerQuoteItem.isLeadTimeEditable}/>
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 pl-0  div-after-d-period align-items-end">
                                        {
                                            isPrevTransLoading ?
                                            <i className="pi pi-spinner mt-3"></i> :
                                            <>
                                                <img src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/cd8f578d-93e7-4810-b947-479180a04e33.png" className='percentile-icon cursor-pointer w-4 mt-3' onClick={(e) => prevTransactionsPopup.current.toggle(e)} />
                                                <Tooltip target=".percentile-icon" position="top" content="View past quotes" showDelay={0} hideDelay={0} />
                                                <OverlayPanel ref={prevTransactionsPopup} className="w-31rem past-transactions-panel p-1 mt-0">
                                                    <h4 className="m-0 text-center mt-1">Past Quote Margins</h4>
                                                    {renderPrevTransPopupTemplate(prevMaterialQuotes)}
                                                </OverlayPanel>
                                            </> 
                                        }
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 pl-0 unit-price">
                                        <label style={{ fontSize: "12px", marginBottom: "3px" }}>
                                            Unit Price
                                            {
                                                relatedBuyerQuoteItem.buyerRateContractId &&
                                                <>
                                                    {relatedBuyerQuoteItem.isUnitPriceEditable ?
                                                        <div>
                                                            <i className='pi pi-save ml-1 cursor-pointer' style={{ fontSize: '0.7rem', color: "green" }} onClick={() => { handleUnitPriceSave() }}></i>
                                                            <i className='pi pi-times ml-1 cursor-pointer ml-2' style={{ fontSize: '0.7rem', color: "red" }} onClick={() => { handleUnitPriceDiscard() }}></i>
                                                        </div>
                                                        :
                                                        <i className='pi pi-pencil ml-1 cursor-pointer' style={{ fontSize: '0.7rem' }} onClick={handleUnitPriceEditClick}></i>
                                                    }
                                                </>
                                            }

                                        </label>
                                        <TextInputField name="bQuotUnitPrice" value={relatedBuyerQuoteItem?.bQuotUnitPrice} onChange={(event) => handleBuyerQuoteUnitPrice(event, relatedBuyerQuoteItem)} keyfilter="num" labelText="" disabled={unitPriceDisableCond} errorBorder={disableMargin && (!relatedBuyerQuoteItem?.bQuotListPrice || !relatedBuyerQuoteItem?.bQuotUnitPrice)} />
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem urp">
                                        <TextInputField name="urp" labelText="URP" value={buyerReq?.isURP ? "Yes" : "No"} disabled />
                                    </div>
                                    {
                                        isHSNEntryAllowed ?
                                            <div className="flex flex-column col-12 lg:col-1 pl-0 w-6rem b-hsn">
                                                <TextInputField labelText="HSN" name="bQuotHSNCode" value={relatedBuyerQuoteItem?.bQuotHSNCode} errorBorder={!relatedBuyerQuoteItem?.bQuotHSNCode} keyfilter="pnum" onChange={handleBuyerQuoteItemsChange} onBlur={(e) => handleVerifyHSNCode(e)} className={`.hsn-code-${buyerReqItemDetails.buyerReqItemId}`} />
                                                <Tooltip target={`.hsn-code-${buyerReqItemDetails.buyerReqItemId}`} position="top" showDelay={0} hideDelay={0}>
                                                    {hsnTitle}
                                                </Tooltip>
                                            </div>
                                            :
                                            null
                                    }
                                    <div className="flex flex-column col-12 lg:col-1 pl-0 w-4rem">
                                        {
                                            true &&
                                            <label htmlFor="sellerListPrice" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                                <span>{pmCompanyConfig.GSTRateLabel}</span>
                                                <Tooltip target=".quote-gst-icon" position="top" content="item's GST rate should be higher or equal to seller(s) GST rate" showDelay={0} hideDelay={0} />
                                            </label>
                                        }
                                        <DropDownField name="bQuoteGSTRate" value={relatedBuyerQuoteItem?.bQuoteGSTRate} options={updatedGSTOptions} id="bQuoteGSTRate" onChange={handleBuyerQuoteItemsChange} className="quote-gst-icon" />
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 px-0 pre-tax-amt">
                                        <TextInputField value={relatedBuyerQuoteItem?.bQuoteItemAmountBeforeTax} labelText="Pre Tax Amt" disabled />
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 total-txt">
                                        <TextInputField value={relatedBuyerQuoteItem?.bQuoteItemTaxAmount} labelText="Total Tax" disabled />
                                    </div>
                                    <div className="flex flex-column col-12 lg:col-1 px-0 total-amt">
                                        <TextInputField value={relatedBuyerQuoteItem?.bQuoteItemAmountWithTax} labelText="Total Amt" disabled />
                                    </div>
                                    {relatedBuyerQuoteItem?.bQuotListPrice && (relatedBuyerQuoteItem?.bQuoteGSTRate || parseFloat(relatedBuyerQuoteItem?.bQuoteGSTRate) === 0) && relatedBuyerQuoteItem?.bQuotUnitPrice ?
                                        <div className="flex flex-column align-items-center col-12 lg:col-2 px-0 profit">
                                            <p className="text-base m-1 font-semibold">P&L:</p>
                                            <div>
                                                <span className={profitClassName}>{profitInDenomination}</span>
                                                {
                                                    totalSellerLogisticsAmount ?
                                                        <>
                                                            <span className={`seller-logistics-${buyerReqItemDetails.buyerReqItemId} ${profitClassName}`}>!</span>
                                                            <Tooltip target={`.seller-logistics-${buyerReqItemDetails.buyerReqItemId}`} position="top" showDelay={0} hideDelay={0}>
                                                                {`${profit}(P&L) - ${totalSellerLogisticsAmount}(Logistics)`}
                                                            </Tooltip>
                                                        </>
                                                        : null
                                                }
                                            </div> 
                                        </div> : null
                                    }
                                </div>
                            </div>
                        </div>)
                    ) : ""
                }
            </div>
        </>
    )
}

export default ListItem